import type { SelectProps } from 'antd'
import { Select as AntdSelect } from 'antd'
import React, { memo } from 'react'
import IconSvg from '@/components/IconSvg'

const Select: any = memo((props: SelectProps) => {
  return (
    <AntdSelect
      maxTagCount="responsive"
      suffixIcon={<IconSvg type="icon-xiala2" />}
      removeIcon={<IconSvg type="icon-close" />}
      dropdownMatchSelectWidth={false}
      {...props}
    />
  )
})

Select.Option = AntdSelect.Option

export default Select
